module.exports = __webpack_public_path__ + "static/media/openSidebar.f49982f8.svg";